module.exports = __webpack_public_path__ + "static/media/logo_dongabank.ffad39b8.svg";